export enum CallbackStatus {
          Ready = -1
        , Unknown = 0
        , Requested = 10
        , Processing = 20
        , CallInProgress = 30
        , Cancelled = 100
        , Error = 110
        , CallNotAnswered = 120
        , CallNotAccepted = 130
        , AccountNotEntered = 131
        , CustomerBusy= 140
        , ExpertBusy= 150
        , InsufficientCredit= 160
        , ExpertNotAccepted= 170
        , ExpertNoAnswer= 180
        , CustomerHungUp= 190
        , CallAnswered= 200
        , CallCompleted= 300
    }
